import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_PROCESOS_JURIDICOS
export default class DocTipoService {
  getAll () {
    return http.get(`${baseUrl}/documentos-tipos`)
  }
}
